/* SOFT SKILLS USER PROGRESS */
export const GET_SOFTSKILLS_USER_PROGRESS = "GET_SOFTSKILLS_USER_PROGRESS"
export const GET_SOFTSKILLS_USER_PROGRESS_SUCCESS =
  "GET_SOFTSKILLS_USER_PROGRESS_SUCCESS"
export const GET_SOFTSKILLS_USER_PROGRESS_ERROR =
  "GET_SOFTSKILLS_USER_PROGRESS_ERROR"
export const GET_SOFTSKILLS_USER_PROGRESS_CLEAN =
  "GET_SOFTSKILLS_USER_PROGRESS_CLEAN"
